export enum IconType {
  Clients = "clients",
  Address = "address",
  Arrow = "arrow",
  BoundingBoxFill = "bounding-box-fill",
  CheckPackage = "checkPackage",
  CheckboxSelect = "checkbox-select",
  Close = "close",
  Comment = "comment",
  Coupon = "coupon",
  Copy = "copy",
  Custom = "custom",
  CurrencyCircleDollarFill = "currency-circle-dollar-fill",
  Dashboard = "dashboard",
  Delete = "delete",
  Delivery = "delivery",
  Exclamation = "exclamation",
  Faq = "faq",
  FileCSV = "fileCSV",
  Fullscreen = "fullscreen",
  GearFill = "gear-fill",
  Remove = "remove",
  Good = "good",
  HeadsetFill = "headset-fill",
  Help = "help",
  HouseFill = "house-fill",
  Id = "id",
  Info = "info",
  LockClosed = "lock-closed",
  LockOpen = "lock-open",
  MapPinFill = "map-pin-fill",
  MailboxFill = "mailbox-fill",
  Money = "money",
  Orders = "orders",
  Package = "package",
  PackageFill = "package-fill",
  Parcel = "parcel",
  Price = "price",
  Process = "process",
  ReceiptFill = "receipt-fill",
  AirplaneTiltFill = "airplane-tilt-fill",
  Add = "add",
  Return = "return",
  Timer = "timer",
  Triangle = "triangle",
  Wrong = "wrong",
  QuestionLight = "question-light",
  LockSimpleLight = "lock-simple-light",
  RadioButtonFill = "radio-button-fill",
  RadioButtonLight = "radio-button-light",
  Vk = "vk",
  Fb = "fb",
  Mailru = "mailru",
  Search = "search",
  Edit = "edit",
  Menu = "menu",
  MenuBurger = "menuBurger",
  AdditionalPhotos = "additionalPhotos",
  PowerCheck = "powerCheck",
  ServiceByInstruction = "serviceByInstruction",
  NotSelectedDelivery = "not-selected-delivery",
  Pause = "pause",
  Filter = "filter",
  PackOptions = "pack-options",
  Fragile = "fragile",
  RemoveBrochure = "remove-brochure",
  RemoveShoeBox = "remove-shoe-box",
  SaveMailBox = "save-mail-box",
  SaveShoeBox = "save-shoe-box",
  ParcelInside = "parcel-inside",
  RightArrow = "right-arrow",
  Messenger = "messenger",
  MpsIcon = "mps-icon",
  SignOutFill = "sign-out-fill",
  Tools = "tools",
  Inventory = "inventory",
  RequestInventoryShipment = "requestInventoryShipment",
  RequestTransferShipment = "requestTransferShipment",
  Transfer = "transfer",
  ViewRows = "view-rows",
  ViewTiles = "view-tiles",
}
